import { View, Card, Image } from "@/components/ui";
import { cn } from "@/lib/utils";
import { Typography } from "../typography";
import type { Notification } from "@/types/notification";
import { formatDate } from "@/lib/helpers/date";
import { getNotificationIcon } from "./lib";

export function NotificationItem({
  item,
  handlePress,
}: {
  item: Notification;
  handlePress(): void;
}) {
  const icon = getNotificationIcon(item);
  return (
    <Card
      onClick={handlePress}
      className={cn(
        "relative flex cursor-pointer flex-row items-start rounded-none border-0 border-b border-border-medium py-3 sm:mx-1",
        item.isRead ? "bg-transparent" : "bg-primary-surface",
      )}
    >
      <View
        className={cn(
          "mx-2 flex h-8 w-8 items-center justify-center rounded-full md:mx-4",
          item.isRead ? "bg-slate-100" : "bg-brand-primary-pressed",
        )}
      >
        <View className="h-6 w-6">
          <Image src={icon} alt={item.subject} />
        </View>
      </View>
      <View className="flex flex-1 flex-col gap-1">
        <Typography variant="body-md" className="line-clamp-1">
          {item.subject}
        </Typography>
        <Typography
          variant="body-sm"
          color="secondary-text"
          className="line-clamp-2"
        >
          {item.shortBody}
        </Typography>
        <Typography variant="caption-md" color="foreground-intermediate">
          {formatDate(
            new Date(item.deliveredAt ?? ""),
            "d MMM yyyy, hh:mm a",
            true,
          )}
        </Typography>
      </View>
    </Card>
  );
}
